import { DocumentViewMode } from "~/types/enums/DocumentViewMode.enum";

export const useCanGradeDocument = (
  submittedDocument: SubmittedDocument,
  mode: DocumentViewMode
) => {
  if (mode == DocumentViewMode.student) return true;

  if (submittedDocument == undefined || submittedDocument.isSample == true)
    return true;

  // If the current logged in user is not the assigned teacher, we assume they can grade it and we'll do some
  // Separqate validation when opening the document to make sure the assigned teacher has sufficient licenses
  if (submittedDocument.userId != useCurrentUID()) {
    return true;
  }

  // If hte document has already been graded we do not need to check capabilities
  if (submittedDocument.state == DocumentState.graded) {
    return true;
  }

  // If the document is a KWO or a rough draft without a checklist we can allow them to grade it
  if (
    submittedDocument.documentSubmissionType ==
    DocumentSubmissionType.keyWordOutline
  ) {
    return true;
  }

  // If hte submittons does not have a checklist we can allow them to grade it
  if (submittedDocument.checklistId == undefined) {
    return true;
  }

  // If the assignment is a general assignment we can allow them to grade it
  // - The checklist == undefined should catch this already but adding this just in case
  if (submittedDocument.assignmentType == AssignmentType.general) {
    return true;
  }

  if (
    submittedDocument.documentSubmissionType ==
    DocumentSubmissionType.roughDraft
  ) {
    if (submittedDocument.assignmentRequireRoughDraftChecklist == false) {
      return true;
    }
  }

  const capabilitiesService = useCapabilitiesServiceStore();
  const { canGradeDocument: checkCanGrade } = storeToRefs(capabilitiesService);

  return checkCanGrade.value(submittedDocument.id!) == true;
};
